module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-action-buttons"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('ModalReveal', {
    ref: "editReveal"
  }, [_c('button', {
    staticClass: "button warning",
    attrs: {
      "slot": "trigger",
      "type": "button"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]), _c('DocumentTypeForm', {
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  }), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.edit
    },
    slot: "footer"
  }, [_vm._v("Save")])], 1), _c('ActionButton', {
    attrs: {
      "action": _vm.remove,
      "confirm": "confirm"
    }
  }, [_vm._v("Delete")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0928d9a0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/DocumentTypeButtons.vue
// module id = 2048
// module chunks = 1